import { createLogger } from "@almamedia/amr-adtech-stack/lib/utils";

const logger = createLogger("etuovi-custom-needs");

declare global {
  interface Window {
    dispatchAdRequestFinished?: (arg0: {
      divId: string;
      page: string;
      adAvailable: boolean;
    }) => void;
  }
}

function dispatchAdRequestFinished(
  divId: string,
  page: string,
  adAvailable: boolean
): void {
  if (typeof window.dispatchAdRequestFinished === "function") {
    window.dispatchAdRequestFinished({ divId, page, adAvailable });
  } else {
    logger.logInfo(`Could not dispatchAdRequestFinished`);
  }
}

// eslint-disable-next-line import/prefer-default-export
export { dispatchAdRequestFinished };
